// extracted by mini-css-extract-plugin
module.exports = {"login-buttons":"O2tUZtoI","loginButtons":"O2tUZtoI","login-button":"_3pV2xfWn","loginButton":"_3pV2xfWn"};